(() => {
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const BLOCK_TAGS = new Set([
    "ADDRESS",
    "ARTICLE",
    "ASIDE",
    "BLOCKQUOTE",
    "DIV",
    "DL",
    "FIELDSET",
    "FIGCAPTION",
    "FIGURE",
    "FOOTER",
    "FORM",
    "H1",
    "H2",
    "H3",
    "H4",
    "H5",
    "H6",
    "HEADER",
    "HR",
    "LI",
    "MAIN",
    "NAV",
    "OL",
    "P",
    "PRE",
    "SECTION",
    "TABLE",
    "UL",
  ]);

  const pushLineBreak = (buffer) => {
    if (!buffer.length || buffer[buffer.length - 1] === "\n") return;
    buffer.push("\n");
  };

  const extractTextWithBreaks = (root) => {
    const buffer = [];

    const walk = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        buffer.push(node.textContent || "");
        return;
      }

      if (node.nodeType !== Node.ELEMENT_NODE) return;

      const element = node;
      const tagName = element.tagName;

      if (tagName === "BR") {
        pushLineBreak(buffer);
        return;
      }

      const isBlock = BLOCK_TAGS.has(tagName);
      if (isBlock && buffer.length) pushLineBreak(buffer);

      Array.from(element.childNodes).forEach(walk);

      if (isBlock) pushLineBreak(buffer);
    };

    Array.from(root.childNodes).forEach(walk);

    return buffer
      .join("")
      .replace(/\r\n?/g, "\n")
      .replace(/\n{3,}/g, "\n\n")
      .trim();
  };

  const splitTextIntoCharacters = (element) => {
    const rawText = extractTextWithBreaks(element);

    element.textContent = "";
    element.setAttribute("aria-label", rawText.replace(/\s+/g, " ").trim());

    const fragment = document.createDocumentFragment();

    for (const char of Array.from(rawText)) {
      if (char === "\n") {
        fragment.appendChild(document.createElement("br"));
        continue;
      }

      const span = document.createElement("span");
      span.className = "text-reveal-char";
      span.dataset.revealed = "false";
      span.textContent = char === " " ? "\u00A0" : char;
      fragment.appendChild(span);
    }

    element.appendChild(fragment);
    return Array.from(element.querySelectorAll(".text-reveal-char"));
  };

  const setupSection = (section) => {
    const revealTargets = Array.from(section.querySelectorAll("[data-reveal-text]"));
    if (!revealTargets.length) return null;

    const chars = revealTargets.flatMap((target) => splitTextIntoCharacters(target));
    if (!chars.length) return null;

    return { section, chars, revealedCount: -1 };
  };

  const sections = Array.from(document.querySelectorAll("[data-text-reveal-section]"))
    .map(setupSection)
    .filter(Boolean);

  if (!sections.length) return;

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (prefersReducedMotion) {
    sections.forEach(({ chars }) => {
      chars.forEach((char) => {
        char.dataset.revealed = "true";
      });
    });
    return;
  }

  let ticking = false;

  const update = () => {
    const viewportHeight = window.innerHeight;

    sections.forEach((item) => {
      const { section, chars } = item;
      const rect = section.getBoundingClientRect();
      const sectionTop = window.scrollY + rect.top;
      const startY = sectionTop - viewportHeight * 0.88;
      const endY = sectionTop + rect.height * 0.35;
      const distance = Math.max(endY - startY, 1);
      const progress = clamp((window.scrollY - startY) / distance, 0, 1);
      const revealedCount = Math.floor(progress * chars.length);

      if (revealedCount === item.revealedCount) return;

      item.revealedCount = revealedCount;

      chars.forEach((char, index) => {
        char.dataset.revealed = index < revealedCount ? "true" : "false";
      });
    });

    ticking = false;
  };

  const requestTick = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  update();

  window.addEventListener("scroll", requestTick, { passive: true });
  window.addEventListener("resize", requestTick);
})();
